<template>
  <header
    :style="{ 'background-image': `url(${imageSrc})` }"
    class="BannerCallToActionWoman"
  >
    <div class="BannerCallToActionWoman-LogoWrapper">
      <img
        class="BannerCallToActionWoman-Logo"
        src="/img/businesswoman-with-tablet.png"
        alt="A imagem apresenta uma mulher segurando um tablet."
      >
    </div>

    <div class="BannerCallToActionWoman-MessageButtonWrapper">
      <div class="BannerCallToActionWoman-MessageWrapper">
        <h1
          class="BannerCallToActionWoman-Message"
          v-html="message"
        />
      </div>

      <div class="BannerCallToActionWoman-ButtonWrapper">
        <rounded-button
          class="BannerCallToActionWoman-Button"
          @click="click()"
        >
          Saiba mais
        </rounded-button>
      </div>
    </div>

    
  </header>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .BannerCallToActionWoman {
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    //overflow: hidden;
    flex-wrap: wrap;
    min-height: 50vh;

    flex-direction: column;
    align-items: center;

    @media screen and (min-width: $desktop-breakpoint) {
      flex-direction: row;
    }

    &-LogoWrapper {
      display: flex;
      justify-self: flex-end;
      justify-content: center;
      flex: 0 0 100%;
      margin: 20px 10px 0;
      height: 100%;
      text-align: center;
      vertical-align: middle;
      min-height: 100px;
      position: relative;
      bottom: 0;
      
      order: 2;

      @media screen and (min-width: $desktop-breakpoint) {
        flex: 0 0 49%;
        order: 1;
      }
    }

    &-Logo {
      flex: 0 0 auto;
      max-width: 40vh;
      max-height: 30vh;

      @media screen and (min-width: $desktop-breakpoint) {
        max-height: 66%;
        max-width: 66%;
      }
    }

    &-MessageButtonWrapper {
      box-sizing: border-box;
      flex: 0 0 100%;
      order: 1;
      width: 100%;
      margin: 20px 0;

      @media screen and (min-width: $desktop-breakpoint) {
        flex: 0 0 49%;
        order: 2;
      }
    }

    &-MessageWrapper {
      justify-content: center;
      align-items: center;
      width: 100%;
    }

    &-Message {
      width: 100%;
      margin: 10px 0;
      padding: 10px 10%;
      box-sizing: border-box;
      text-align: center;
      font-size: 20pt;
      color: $color-primary-foreground;
    }

    &-ButtonWrapper {
      margin: 20px 0;
      width: 100%;
      text-align: center;

      @media screen and (min-width: $desktop-breakpoint) {
        margin: 50px 0;
      }
    }

    &-Button {
      max-width: 200px;
      display: inline-block;
    }
  }
</style>

<script>
  import TheButton from "@/components/TheButton";
  import TheIcon from "@/components/TheIcon";
  import RoundedButton from './RoundedButton.vue';

  export default {
    name: "BannerCallToActionWoman",

    components: {
      TheIcon,
      TheButton,
      RoundedButton,
    },

    props: {
      imageSrc: {
        type: String,
        default: "img/backgrounds/students-doing-exam.jpg",
      },

      message: {
        type: String,
        default: "",
      },

      buttonText: {
        type: String,
        default: "Ação",
      },
    },

    methods: {
      click() {
        this.$emit("click");
      },
    },
  };
</script>
